<template>
    <div v-if="showModal">
        <div class="backdrop" @click="close"></div>
        <div class="card card-outline card-primary card-box mx-auto">

            <div class="card-header">
                <h3 class="card-title">{{ modalTitle }}</h3>
                <div class="card-tools">
                    <button type="button"
                            class="btn btn-tool"
                            @click="close"
                    >
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="modal-card-body">
                <label
                        class="required-field-asterisks"
                        for="reject-reason"
                >{{ fieldName }}</label>
                <textarea
                        id="reject-reason"
                        class="form-control form-control-lg"
                        :class="{ 'is-invalid': $v.rejectReason.$error }"
                        @input="delayTouch($v.rejectReason)"
                        :placeholder="fieldName"
                        v-model="rejectReason"
                        :readonly="rejectReasonReadonly"
                ></textarea>
                <FormError error="Veuillez renseigner le motif"
                           v-if="$v.rejectReason.$error"
                ></FormError>
            </div>

            <div class="modal-card-actions text-right">
                <button v-if="isAbort"
                        class="btn btn-primary button-blue"
                        :disabled="$v.$invalid || isLoading"
                        @click.prevent="abort"
                >
                    <span>{{ rejectButtonCaption }}</span>
                    <span
                            v-if="isLoading"
                            class="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                    ></span>
                </button>
                <button v-else class="btn btn-primary button-blue"
                        :disabled="$v.$invalid || isLoading"
                        @click.prevent="reject"
                >
                    <span>Refuser</span>
                    <span
                            v-if="isLoading"
                            class="spinner-border spinner-border-sm ml-2"
                            role="status"
                            aria-hidden="true"
                    ></span>
                </button>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import { required } from 'vuelidate/lib/validators';
    import FormError from '../FormError';
    import ValidationDelayTouch from '../../mixins/validationDelayTouch';
    import { successMessage, messageTexts } from '../../utils/sweet-alert-options';

    export default {
        mixins: [ValidationDelayTouch],
        props: {
            modalTitle: String,
            fieldName: String,
            showModal: Boolean,
            isAbort: Boolean,
            exemption: Object
        },
        data() {
            return {
                rejectReason: '',
                isLoading: false,
                rejectReasonReadonly: false,
            };
        },
        computed: {
            rejectButtonCaption() {
                return this.exemption.status === 'to_abort' ? 'Accepter l’abandon' : 'Abandonner';
            },
        },
        watch: {
            exemption(value) {
                if (value.status === 'to_abort') {
                    this.rejectReason = value.rejectReason;
                    this.rejectReasonReadonly = true;
                }
            },
        },
        methods: {
            async abort() {
                this.isLoading = true;
                try {
                    await axios.post(
                        `/exemptions/${ this.exemption.id }/abort`,
                        { rejectReason: this.rejectReason }
                    );
                    this.$emit('abortSuccess');
                    this.isLoading = false;
                    this.close();
                } catch ({ response }) {
                    this.isLoading = false;
                }
            },
            async reject() {
                this.isLoading = true;
                try {
                    await axios.post(
                        `/exemptions/${ this.exemption.id }/reject`,
                        { rejectReason: this.rejectReason }
                    );
                    await this.$router.push({ name: 'exemption-list' });
                    this.$swal({ title: messageTexts.rejectSuccess, ...successMessage });
                } catch ({ response }) {
                    // Todo handle backend errors
                }
            },
            close() {
                if (!this.isLoading) {
                    this.rejectReason = '';
                    this.$nextTick(() => { this.$v.$reset() });
                    this.$emit('update:showModal', false);
                }
            }
        },
        validations: {
            rejectReason: {
                required
            }
        },
        components: {
            FormError
        }
    }
</script>